import { connect, useSelector } from 'react-redux'
import React, { useState } from 'react'
import { jt, t } from 'ttag'

import {
  loadSubsequentWorkKeysResults,
  loadWorkKeysResults
} from '../../../actions/assessments/workkeys'
import { useTitleChange } from '../../../util/hooks'
import SearchQueryHandlerComponent from '../../../components/search/SearchQueryHandlerComponent'

const WorkKeysResults = props => {
  const pageTitle = t`WorkKeys Results`

  useTitleChange(pageTitle)
  const [filterModel, setFilterModel] = useState({})
  const loadFunction = loadWorkKeysResults
  const loadMoreFunction = loadSubsequentWorkKeysResults(filterModel)
  const searchRequest = useSelector(state => state.assessments.workKeys.results)

  return [
    <div className="container">
      <p>
        {jt`Your workkeys profile returned the following occupations. You can compare up to four occupations by selecting the boxes to the 
                left of the desired occupations and then clicking on the Compare Selected button at the bottom of the page. You can also filter occupation 
                lists by Job Zone (preparation required), salary, and more to help you refine your search.`}
      </p>
    </div>,
    <SearchQueryHandlerComponent
      loadFunction={loadFunction}
      key="wk-results"
      loadMoreFunction={loadMoreFunction}
      setFilterModel={setFilterModel}
      searchRequest={searchRequest}
      {...props}
    />
  ]
}

export default WorkKeysResults
